import PropTypes from "prop-types";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

/* Wrapper mínimo de recharts para o Portal do Responsável — não reaproveita
   pages/InteligenciaEducacional/components/charts/Charts.jsx de propósito
   (módulo independente), e não precisa da mesma variedade de gráficos: aqui
   é sempre "uma ou mais métricas do aluno ao longo do tempo". */
export function LinhaTemporal({
  dados,
  xKey,
  series,
  altura,
  formatoY,
  dominioY
}) {
  return (
    <ResponsiveContainer width="100%" height={altura}>
      <LineChart
        data={dados}
        margin={{ top: 8, right: 12, left: -6, bottom: 0 }}
      >
        <CartesianGrid
          stroke="#eef0f3"
          strokeDasharray="4 6"
          vertical={false}
        />
        <XAxis
          dataKey={xKey}
          tick={{ fontSize: 11, fill: "#8a93a2" }}
          tickLine={false}
          axisLine={{ stroke: "#eef0f3" }}
        />
        <YAxis
          tick={{ fontSize: 11, fill: "#8a93a2" }}
          tickLine={false}
          axisLine={false}
          width={38}
          domain={dominioY}
          tickFormatter={formatoY}
        />
        <Tooltip formatter={formatoY ? v => formatoY(v) : undefined} />
        {series.length > 1 && (
          <Legend wrapperStyle={{ fontSize: 12 }} iconType="circle" />
        )}
        {series.map(s => (
          <Line
            key={s.key}
            type="monotone"
            dataKey={s.key}
            name={s.label}
            stroke={s.color}
            strokeWidth={2.5}
            dot={{ r: 3, strokeWidth: 0, fill: s.color }}
            connectNulls
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}

LinhaTemporal.propTypes = {
  dados: PropTypes.arrayOf(PropTypes.object).isRequired,
  xKey: PropTypes.string.isRequired,
  series: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string,
      color: PropTypes.string
    })
  ).isRequired,
  altura: PropTypes.number,
  formatoY: PropTypes.func,
  dominioY: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  )
};

LinhaTemporal.defaultProps = {
  altura: 200,
  formatoY: undefined,
  dominioY: undefined
};
